/**
 * @desc 更新
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.WarehouseMasterRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/fulfilment/warehouseMaster/updateData`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
